<template>
    <div>
        <template v-if="tipo_lista_categoria == 'L'">
            <az-input
                sizing="sm"
                label="Categoria"
                :required="!block_required"
                :validate="validate"
                type="select"
                optionsMode="aql"
                :edicao="!block_edicao"
                service="categorias.index"
                :optionsName="'categorias.' + ( ch_tipo_lancamento ? ch_tipo_lancamento : 'X' )"
                optionsData="id_categoria"
                optionsDisplay="search"
                :optionsParm="{ lancamento: true, where: { ch_natureza: ch_tipo_lancamento ? ch_tipo_lancamento : '?' } }"
                v-model="conteudo">
                <template v-slot:buttonposb>
                    <div class="input-group-append" v-if="!block_tipo_lista_categoria">
                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="alterar_tipo_lista()">
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </button>
                        <slot name="buttonposb"></slot>
                    </div>
                </template>
            </az-input>
        </template>
        <template v-else>
            <az-input
                sizing="sm"
                label="Categoria"
                :required="!block_required"
                :validate="validate"
                type="autocomplete"
                optionsMode="aql"
                :edicao="!block_edicao"
                service="categorias.index"
                :optionsName="'categorias.' + ( ch_tipo_lancamento ? ch_tipo_lancamento : 'X' )"
                optionsData="id_categoria"
                optionsDisplay="search"
                :optionsParm="{ lancamento: true, natureza: ( ch_tipo_lancamento ? ch_tipo_lancamento : '?' ) }"
                v-model="conteudo">
                <template v-slot:buttonposb>
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="alterar_tipo_lista()">
                            <i class="fas fa-caret-square-down"></i>
                        </button>
                        <slot name="buttonposb"></slot>
                    </div>
                </template>
            </az-input>
        </template>
    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            conteudo: "", 
            tipo_lista_categoria: 'L', 
        };
    },

    props: ['value', 'validate', 'block_edicao', 'ch_tipo_lancamento', 'block_required', 'block_tipo_lista_categoria', 'tipo_lista_categoria_default'],

    components: { 
        AzInput,
    },

    watch: { 
        conteudo: function (newValue) {
            this.$emit('input', newValue);
        },
    },

    methods: { 
        updateValue(event) {
            this.$emit('input', event.target.value);
        },

        alterar_tipo_lista() { 
            this.conteudo = "";
            this.tipo_lista_categoria = ( this.tipo_lista_categoria == 'L' ? 'B' : 'L' );
            this.$util.setCookie('tipo_lista_categoria', this.tipo_lista_categoria);
        },
    },

    mounted() { 
        if ( this.block_tipo_lista_categoria ) { 
            this.tipo_lista_categoria = this.block_tipo_lista_categoria; 
        } else if ( this.tipo_lista_categoria_default ) { 
            this.tipo_lista_categoria = this.tipo_lista_categoria_default;
        } else { 
            this.tipo_lista_categoria = this.$util.getCookie('tipo_lista_categoria') 
                ? this.$util.getCookie('tipo_lista_categoria') 
                : 'L';
        }

        this.conteudo = this.value;
    }
}
</script>